import { getBasicConfig } from '@/api/config'

export default {
  name: 'configMixin',
  data: () => ({
    config: {},
    qiniuUrl: 'https://qn.feijing88.com/',
    lottetyQiniuUrl: 'http://qn.365rich.com'
  }),
  created () {
    getBasicConfig().then((config) => {
      this.config = config
    }).catch(({ message }) => {
      this.$message({ type: 'error', message })
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/config.js